import axios from "axios";
import store from './../index'
import router from '../../config/router'

export default {
  state: {
    access: localStorage.getItem('PHC_accT'),
    refresh: localStorage.getItem('PHC_refT'),
  },
  getters: {
    ACCESS_TOKEN: state => {
      return state.access;
    },
    REFRESH_TOKEN: state => {
      return state.refresh;
    },
  },
  mutations: {
    SET_TOKENS: (state, payload) => {
      state.access = payload.access
      state.refresh = payload.refresh
      localStorage.setItem('PHC_accT', state.access);
      localStorage.setItem('PHC_refT', state.refresh);
    },
    CLEAR_TOKENS: (state) => {
      state.access = ''
      state.refresh = ''
      localStorage.removeItem('PHC_accT');
      localStorage.removeItem('PHC_refT');
    },
  },
  actions: {
    CREATE_TOKENS: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Token/CreateAll`, payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200 && data.accessToken && data.refreshToken) {

              let Tokens = {
                access: data.accessToken,
                refresh: data.refreshToken
              }
              store.commit('SET_TOKENS', Tokens);
              store.commit('SET_USER', data.user);

              resolve(true);

            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // Выход из аккаунта (кнопка в Toolbar) и принудительный выход при неудачном refresh токена.
    // Раньше делался router.push('/login') — SPA жила дальше, и в Vuex-store оставалось всё от прошлой сессии:
    // соединение SignalR (из-за него после повторного логина не рендерился список товаров, см. hub.js),
    // заказы, реклама, рабочий БИН, состояние поиска и т.д. Полная перезагрузка на /login сбрасывает
    // store, таймеры и соединения целиком — надёжнее, чем вручную чистить 38 модулей.
    CLEAR_TOKENS: () => {
      return new Promise((resolve) => {
        const currentLang = localStorage.getItem('CURRENT_LANG');
        store.commit('CLEAR_TOKENS');
        localStorage.clear();
        // язык интерфейса — не данные сессии, оставляем выбранный
        if (currentLang) localStorage.setItem('CURRENT_LANG', currentLang);
        const loginPath = router.resolve({ name: 'login' }).href;
        window.location.replace(loginPath);
        resolve(true);
      });
    },
    UPDATE_TOKENS: (commit, payload) => {
      return new Promise((resolve, reject) => {

        axios
          .post(`/Token/Update`, payload)
          .then(({
            data,
            status
          }) => {

            if (status === 200 && data.accessToken && data.refreshToken) {
              let Tokens = {
                access: data.accessToken,
                refresh: data.refreshToken
              }

              store.commit('SET_TOKENS', Tokens);

              resolve(true);
            }
          })
          .catch(error => {
            reject(error);
          })

      });

    }
  }
};